import styled from 'styled-components'

import { Button, untilMd } from '@syconium/little-miss-figgy'

/**
 * The control and the title on one line, over the divider that separates them from the form.
 */
export const FormHeaderRow = styled.header`
  align-items: center;
  border-bottom: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  display: flex;
  gap: ${o => o.theme.spacing(4)};
  padding-bottom: ${o => o.theme.spacing(5)};

  ${untilMd} {
    display: none;
  }
`

/** A circle the chevron sits in, so it reads as a control without a word beside it. */
export const BackButton = styled(Button)`
  background-color: ${o => o.theme.color.fill.subtle};
  border-radius: 50%;
  height: ${o => o.theme.spacing(8)};
  min-height: 0;
  min-width: 0;
  padding: 0;
  width: ${o => o.theme.spacing(8)};
`

export const FormTitle = styled.h2`
  text-transform: uppercase;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 2.1px;
`
